import PropTypes from "prop-types";
import { ROLES } from "../constants/roles";

export default function RoleBadge({ role, size = "sm" }) {
	const config = ROLES[role];
	if (!config) return <span className="text-xs text-slate-500">{role}</span>;

	const Icon = config.icon;
	const sizeClasses =
		size === "xs" ? "px-2 py-0.5 text-[10px]" : "px-3 py-1 text-xs";

	return (
		<span
			className={`inline-flex items-center gap-1.5 font-semibold rounded-full border ${config.badgeClass} ${sizeClasses}`}
		>
			<Icon className={size === "xs" ? "w-2.5 h-2.5" : "w-3.5 h-3.5"} />
			{config.label}
		</span>
	);
}

RoleBadge.propTypes = {
	role: PropTypes.string.isRequired,
	size: PropTypes.oneOf(["xs", "sm"]),
};
